import { createFileRoute } from '@tanstack/react-router'
import CompanyFormSetsPage from '../components/company-form-sets/CompanyFormSetsPage'

export const Route = createFileRoute('/_a/companies/$companyId/formSets')({
  component: CompanyFormSetsPage,
})
